// SC-1323: the shared core dictionary for every PlayerCore component, in the union of the podcast
// (en nl de es) and portal (+ da fr it pl pt sv) locales. Page-only strings (podcast poster/end
// screen, portal messages) stay with their page and are merged in through `messages`.
export const CORE_LOCALES = ["en", "nl", "de", "es", "da", "fr", "it", "pl", "pt", "sv"]

const LOCALE_ALIASES = { be: "nl" }

export const coreMessages = {
    en: {
        Chapters: "Chapters",
        "Chapter {n}": "Chapter {n}",
        Close: "Close",
        Transcript: "Transcript",
        "Open transcript": "Open transcript",
        "Close transcript": "Close transcript",
        "Loading transcript…": "Loading transcript…",
        "No transcript available": "No transcript available",
        Settings: "Settings",
        Quality: "Quality",
        Auto: "Auto",
        Play: "Play",
        Dismiss: "Dismiss",
        Video: "Video",
        Audio: "Audio",
        "Switch to audio": "Switch to audio",
        "Switch to video": "Switch to video",
        "Listening to audio": "Listening to audio",
        "Video unavailable": "Video unavailable",
        "This video can't be played right now. Please try again later.": "This video can't be played right now. Please try again later.",
    },
    nl: {
        Chapters: "Hoofdstukken",
        "Chapter {n}": "Hoofdstuk {n}",
        Close: "Sluiten",
        Transcript: "Transcript",
        "Open transcript": "Transcript openen",
        "Close transcript": "Transcript sluiten",
        "Loading transcript…": "Transcript laden…",
        "No transcript available": "Geen transcript beschikbaar",
        Settings: "Instellingen",
        Quality: "Kwaliteit",
        Auto: "Auto",
        Play: "Afspelen",
        Dismiss: "Verbergen",
        Video: "Video",
        Audio: "Audio",
        "Switch to audio": "Overschakelen naar audio",
        "Switch to video": "Overschakelen naar video",
        "Listening to audio": "Je luistert naar de audio",
        "Video unavailable": "Video niet beschikbaar",
        "This video can't be played right now. Please try again later.": "Deze video kan nu niet worden afgespeeld. Probeer het later opnieuw.",
    },
    de: {
        Chapters: "Kapitel",
        "Chapter {n}": "Kapitel {n}",
        Close: "Schließen",
        Transcript: "Transkript",
        "Open transcript": "Transkript öffnen",
        "Close transcript": "Transkript schließen",
        "Loading transcript…": "Transkript wird geladen…",
        "No transcript available": "Kein Transkript verfügbar",
        Settings: "Einstellungen",
        Quality: "Qualität",
        Auto: "Auto",
        Play: "Abspielen",
        Dismiss: "Ausblenden",
        Video: "Video",
        Audio: "Audio",
        "Switch to audio": "Zu Audio wechseln",
        "Switch to video": "Zu Video wechseln",
        "Listening to audio": "Sie hören die Audioversion",
        "Video unavailable": "Video nicht verfügbar",
        "This video can't be played right now. Please try again later.": "Dieses Video kann gerade nicht abgespielt werden. Bitte versuchen Sie es später erneut.",
    },
    es: {
        Chapters: "Capítulos",
        "Chapter {n}": "Capítulo {n}",
        Close: "Cerrar",
        Transcript: "Transcripción",
        "Open transcript": "Abrir transcripción",
        "Close transcript": "Cerrar transcripción",
        "Loading transcript…": "Cargando transcripción…",
        "No transcript available": "No hay transcripción disponible",
        Settings: "Ajustes",
        Quality: "Calidad",
        Auto: "Auto",
        Play: "Reproducir",
        Dismiss: "Ocultar",
        Video: "Vídeo",
        Audio: "Audio",
        "Switch to audio": "Cambiar a audio",
        "Switch to video": "Cambiar a vídeo",
        "Listening to audio": "Estás escuchando el audio",
        "Video unavailable": "Vídeo no disponible",
        "This video can't be played right now. Please try again later.": "Este vídeo no se puede reproducir ahora. Inténtalo de nuevo más tarde.",
    },
    da: {
        Chapters: "Kapitler",
        "Chapter {n}": "Kapitel {n}",
        Close: "Luk",
        Transcript: "Transskription",
        "Open transcript": "Åbn transskription",
        "Close transcript": "Luk transskription",
        "Loading transcript…": "Indlæser transskription…",
        "No transcript available": "Ingen transskription tilgængelig",
        Settings: "Indstillinger",
        Quality: "Kvalitet",
        Auto: "Auto",
        Play: "Afspil",
        Dismiss: "Skjul",
        Video: "Video",
        Audio: "Lyd",
        "Switch to audio": "Skift til lyd",
        "Switch to video": "Skift til video",
        "Listening to audio": "Du lytter til lyden",
        "Video unavailable": "Video utilgængelig",
        "This video can't be played right now. Please try again later.": "Denne video kan ikke afspilles lige nu. Prøv igen senere.",
    },
    fr: {
        Chapters: "Chapitres",
        "Chapter {n}": "Chapitre {n}",
        Close: "Fermer",
        Transcript: "Transcription",
        "Open transcript": "Ouvrir la transcription",
        "Close transcript": "Fermer la transcription",
        "Loading transcript…": "Chargement de la transcription…",
        "No transcript available": "Aucune transcription disponible",
        Settings: "Paramètres",
        Quality: "Qualité",
        Auto: "Auto",
        Play: "Lire",
        Dismiss: "Masquer",
        Video: "Vidéo",
        Audio: "Audio",
        "Switch to audio": "Passer à l'audio",
        "Switch to video": "Passer à la vidéo",
        "Listening to audio": "Vous écoutez l'audio",
        "Video unavailable": "Vidéo indisponible",
        "This video can't be played right now. Please try again later.": "Cette vidéo ne peut pas être lue pour le moment. Veuillez réessayer plus tard.",
    },
    it: {
        Chapters: "Capitoli",
        "Chapter {n}": "Capitolo {n}",
        Close: "Chiudi",
        Transcript: "Trascrizione",
        "Open transcript": "Apri la trascrizione",
        "Close transcript": "Chiudi la trascrizione",
        "Loading transcript…": "Caricamento della trascrizione…",
        "No transcript available": "Nessuna trascrizione disponibile",
        Settings: "Impostazioni",
        Quality: "Qualità",
        Auto: "Auto",
        Play: "Riproduci",
        Dismiss: "Nascondi",
        Video: "Video",
        Audio: "Audio",
        "Switch to audio": "Passa all'audio",
        "Switch to video": "Passa al video",
        "Listening to audio": "Stai ascoltando l'audio",
        "Video unavailable": "Video non disponibile",
        "This video can't be played right now. Please try again later.": "Questo video non può essere riprodotto ora. Riprova più tardi.",
    },
    pl: {
        Chapters: "Rozdziały",
        "Chapter {n}": "Rozdział {n}",
        Close: "Zamknij",
        Transcript: "Transkrypcja",
        "Open transcript": "Otwórz transkrypcję",
        "Close transcript": "Zamknij transkrypcję",
        "Loading transcript…": "Wczytywanie transkrypcji…",
        "No transcript available": "Brak transkrypcji",
        Settings: "Ustawienia",
        Quality: "Jakość",
        Auto: "Auto",
        Play: "Odtwórz",
        Dismiss: "Ukryj",
        Video: "Wideo",
        Audio: "Audio",
        "Switch to audio": "Przełącz na audio",
        "Switch to video": "Przełącz na wideo",
        "Listening to audio": "Słuchasz wersji audio",
        "Video unavailable": "Wideo niedostępne",
        "This video can't be played right now. Please try again later.": "Tego filmu nie można teraz odtworzyć. Spróbuj ponownie później.",
    },
    pt: {
        Chapters: "Capítulos",
        "Chapter {n}": "Capítulo {n}",
        Close: "Fechar",
        Transcript: "Transcrição",
        "Open transcript": "Abrir transcrição",
        "Close transcript": "Fechar transcrição",
        "Loading transcript…": "A carregar a transcrição…",
        "No transcript available": "Nenhuma transcrição disponível",
        Settings: "Definições",
        Quality: "Qualidade",
        Auto: "Auto",
        Play: "Reproduzir",
        Dismiss: "Ocultar",
        Video: "Vídeo",
        Audio: "Áudio",
        "Switch to audio": "Mudar para áudio",
        "Switch to video": "Mudar para vídeo",
        "Listening to audio": "Está a ouvir o áudio",
        "Video unavailable": "Vídeo indisponível",
        "This video can't be played right now. Please try again later.": "Este vídeo não pode ser reproduzido agora. Tente novamente mais tarde.",
    },
    sv: {
        Chapters: "Kapitel",
        "Chapter {n}": "Kapitel {n}",
        Close: "Stäng",
        Transcript: "Transkription",
        "Open transcript": "Öppna transkription",
        "Close transcript": "Stäng transkription",
        "Loading transcript…": "Läser in transkription…",
        "No transcript available": "Ingen transkription tillgänglig",
        Settings: "Inställningar",
        Quality: "Kvalitet",
        Auto: "Auto",
        Play: "Spela",
        Dismiss: "Dölj",
        Video: "Video",
        Audio: "Ljud",
        "Switch to audio": "Byt till ljud",
        "Switch to video": "Byt till video",
        "Listening to audio": "Du lyssnar på ljudet",
        "Video unavailable": "Videon är inte tillgänglig",
        "This video can't be played right now. Please try again later.": "Videon kan inte spelas upp just nu. Försök igen senare.",
    },
}

export function resolveLocale(locale, supported = CORE_LOCALES) {
    const language = String(locale ?? "").toLowerCase().split(/[-_]/)[0]
    const base = LOCALE_ALIASES[language] ?? language

    return supported.includes(base) ? base : "en"
}

export function createTranslator(locale, { supported = CORE_LOCALES, messages = {} } = {}) {
    const code = resolveLocale(locale, supported)
    const dictionary = { ...coreMessages[code], ...(messages[code] ?? {}) }
    const english = { ...coreMessages.en, ...(messages.en ?? {}) }

    return (key, vars = {}) => {
        const template = dictionary[key] ?? english[key] ?? key

        return template.replace(/\{(\w+)\}/g, (match, name) => (name in vars ? String(vars[name]) : match))
    }
}
